const features = [
  {
    icon: 'ri-shield-check-line',
    title: '真实可靠',
    desc: '多方交叉验证每一条吃瓜爆料黑料，标注来源与可信度。我们对吃瓜爆料每日大赛所有参赛内容进行人工审核，确保信息准确度，拒绝虚假吃瓜。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速追踪',
    desc: '7×24小时全网监测，吃瓜爆料视频和每日热点爆料吃瓜内容实时推送。从事件爆发到深度追踪，第一时间为你呈现完整爆料链条。',
  },
  {
    icon: 'ri-lock-line',
    title: '匿名安全',
    desc: '投稿者信息端到端加密存储，吃瓜爆料黑料网采用零知识证明技术保护隐私。你的身份只有你自己知道，大胆爆料，放心吃瓜。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            平台特色
          </h2>
          <p className="text-sm text-foreground-500">为什么千万吃瓜群众选择我们</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((item, i) => (
            <div key={i} className="text-center p-6 md:p-8 rounded-xl bg-background-50 border border-background-200 hover:border-primary-200 transition-all group cursor-default">
              <div className="w-16 h-16 mx-auto mb-5 rounded-2xl bg-primary-50 flex items-center justify-center group-hover:bg-primary-100 transition-colors">
                <i className={`${item.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="text-lg font-heading font-bold text-foreground-800 mb-3">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}